export default __webpack_public_path__ + "static/0140-ab4431cd5d1e0549d5fa34d9864df498.png";